function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M497.215,289.819a7.414,7.414,0,1,0,2.173,5.244A7.4,7.4,0,0,0,497.215,289.819Zm-1.087,1.087a5.879,5.879,0,1,1-4.157-1.721A5.862,5.862,0,0,1,496.128,290.906Z",
  transform: "translate(-484.556 -287.646)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M494.466,292.336a.776.776,0,0,0-1.1,0l-2.636,2.636-1.2-1.2a.775.775,0,1,0-1.1,1.1l1.751,1.751a.777.777,0,0,0,1.1,0l3.184-3.184A.777.777,0,0,0,494.466,292.336Z",
  transform: "translate(-484.034 -287.008)"
});

function SvgStatusSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.832,
    height: 14.832,
    viewBox: "0 0 14.832 14.832",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusSuccess);
export default __webpack_public_path__ + "static/media/status_success.ee4faef5a5264bfc47e4a6f4daf35959.svg";
export { ForwardRef as ReactComponent };